var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-404"},[_c('img',{attrs:{"src":(_vm.cdnUrl + "/static/images/404.png")}}),_c('div',{staticStyle:{"margin-top":"20px"}},[_c('el-button',{on:{"click":function($event){return _vm.goBack()}}},[_vm._v("返回")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }